var _polygon, _rect, _path, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _rect5, _rect6, _rect7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path3, _circle16, _path4, _path5, _path6, _path7, _path8, _circle17, _path9, _ellipse, _circle18, _path10, _rect8, _path11, _rect9, _path12, _rect10, _path13, _rect11, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f6465fa9-e96b-4112347-83dd-e88551c8123123a87",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 802.88442,
    height: 230,
    viewBox: "0 0 802.88442 710.17168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "like dislike") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "633.038 710.172 93.241 520.955 246.731 83.078 802.884 254.625 633.038 710.172",
    fill: "#eb6475"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.88442,
    y: 707.62466,
    width: 648,
    height: 2,
    fill: "#2f2e41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M830.02643,803.83155l-2.198-1.13524C856.37364,747.51039,841.1095,675.843,823.279,625.43954a543.26531,543.26531,0,0,0-46.101-97.29606l2.09053-1.32123a546.04239,546.04239,0,0,1,46.34132,97.79122C843.60462,675.47824,858.97624,747.86062,830.02643,803.83155Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 799.75378,
    y: 570.14894,
    width: 89.26443,
    height: 2.47258,
    transform: "matrix(0.17975, -0.98371, 0.98371, 0.17975, -68.02518, 1204.6276)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 783.78792,
    y: 586.62652,
    width: 2.47426,
    height: 121.62985,
    transform: "translate(-429.2823 613.56156) rotate(-42.93968)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 837.57889,
    y: 728.44421,
    width: 71.73847,
    height: 2.47375,
    transform: "translate(-428.166 915.37325) rotate(-54.13715)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 525.25129,
    cy: 492.15614,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.66549,
    cy: 504.52301,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.93176,
    cy: 552.75378,
    r: 12.36686,
    fill: "#f2f2f2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.51756,
    cy: 583.67094,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 668.70691,
    cy: 597.27449,
    r: 12.36686,
    fill: "#f2f2f2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 697.15069,
    cy: 636.84845,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.29862,
    cy: 411.77153,
    r: 12.36686,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5204,649.31768l-1.74332-1.75524c44.10966-43.75676,51.58588-116.64929,50.09126-170.0927a543.26577,543.26577,0,0,0-14.00287-106.75085l2.3952-.61558a546.04165,546.04165,0,0,1,14.07958,107.29588C896.84955,531.33208,889.25611,604.938,844.5204,649.31768Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 884.91937,
    y: 431.26998,
    width: 89.26443,
    height: 2.47258,
    transform: "translate(-89.80586 952.16033) rotate(-61.7655)",
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 848.46981,
    y: 425.84948,
    width: 2.47426,
    height: 121.62985,
    transform: "translate(-324.70555 311.03405) rotate(-25.06009)",
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 872.74127,
    y: 590.84276,
    width: 71.73847,
    height: 2.47375,
    transform: "translate(-372.78583 557.32555) rotate(-36.25756)",
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 769.01848,
    cy: 266.27111,
    r: 12.36686,
    fill: "#f2f2f2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.49422,
    cy: 315.51135,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.48358,
    cy: 343.98706,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 621.1367,
    cy: 382.29478,
    r: 12.36686,
    fill: "#f2f2f2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.76448,
    cy: 459.17933,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.7483,
    cy: 459.59629,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.66845,
    cy: 505.99173,
    r: 12.36686,
    fill: "#3f3d56"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 676.19033,
    cy: 251.91828,
    r: 12.36686,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M483.03978,203.73173a24.89666,24.89666,0,0,1-3.09294-33.56749c-.5013.47-.99133.95808-1.46043,1.47691a24.8996,24.8996,0,0,0,36.939,33.39868c.46909-.51882.90545-1.05539,1.32279-1.60135A24.89665,24.89665,0,0,1,483.03978,203.73173Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.14796,
    cy: 63.73112,
    r: 51.28132,
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M342.57225,789.8015s-13.6355,13.6355,0,13.6355,26.67814-8.89272,26.67814-8.89272Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M540.90435,781.256s-3.77394,18.9106,7.56833,11.34227,17.25553-22.20474,17.25553-22.20474Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.55714,338.64446l-8.89271,20.74967-54.542,72.32741s-37.3494,40.31364-16.59973,42.685,34.38516-37.3494,34.38516-37.3494l64.02754-63.4347,7.11417-29.04953Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M420.82814,254.4601l-8.5936,2.40592s-33.49859,59.25023-29.9415,71.7,19.564,27.86384,26.67814,26.67815S420.82814,254.4601,420.82814,254.4601Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M448.09913,190.43256s8.89271,36.75655,2.37139,43.87072-20.74967,12.4498-20.74967,12.4498l2.37139,66.39894s27.271-9.48557,28.45669-10.67126S486.04137,262.76,486.04137,262.76l23.71391-22.52821s-36.16371-17.19258-25.49245-46.835S448.09913,190.43256,448.09913,190.43256Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#ffb8b8"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.4767,
    cy: 78.55231,
    r: 30.82808,
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M435.05648,243.78884s-21.93536,5.92848-23.12106,14.22835,0,25.49244-1.77854,29.04953-7.11417,8.89271-4.74278,31.42092,1.18569,36.16371,1.18569,36.16371S286.25173,779.13024,328.93675,791.58s105.52688-1.18569,104.934-9.48556-11.2641-172.51866-11.2641-172.51866,62.249,218.16793,139.31919,167.183,59.87761-60.47045,52.76344-64.02754S500.26972,540.21265,500.86256,508.79173s-1.18569-129.83363-14.22834-144.65482c0,0,13.6355-45.05642,20.15682-50.98489s22.52821-61.65616,22.52821-61.65616-10.07841-13.63549-18.37828-13.63549-16.00688,2.96424-25.49244,11.857S440.985,301.88791,440.985,301.88791,429.72085,252.08871,435.05648,243.78884Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.18027,
    cy: 50.9849,
    rx: 26.0853,
    ry: 17.78543,
    fill: "#2f2e41"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.64385,
    cy: 24.8996,
    r: 24.8996,
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M531.98706,137.3727a24.89666,24.89666,0,0,1-24.80682-22.82464c-.05659.68487-.09278,1.37552-.09278,2.075a24.8996,24.8996,0,1,0,49.7992,0c0-.69945-.03618-1.3901-.09277-2.075A24.89667,24.89667,0,0,1,531.98706,137.3727Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 251.00155,
    width: 122.62312,
    height: 122.62312,
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M240.49916,405.28832s15.51257-2.21608,20.68342-16.25126,9.603-25.85427,18.46734-23.63819,3.69346,30.28643,3.69346,30.28643,18.46734-2.21608,19.206,4.43216c.61161,5.50448.21045,26.707.05431,33.83941a14.6163,14.6163,0,0,1-2.5474,8.08145,10.6564,10.6564,0,0,1-10.80339,4.61683,86.23893,86.23893,0,0,0-12.35576-.64616,37.6677,37.6677,0,0,1-20.88543-6.00207h0l-15.51257-.73869Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#f2f2f2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18.30318,
    y: 300.25894,
    width: 31.76382,
    height: 53.92462,
    fill: "#eb6475"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.26332,375.13642a11.04488,11.04488,0,0,1-3.15172-.453l.21065-.70768a10.46145,10.46145,0,0,0,13.26185-8.07152l.72571.13778a11.16668,11.16668,0,0,1-11.04649,9.09444Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 318.14573,
    y: 404.62466,
    width: 122.62312,
    height: 122.62312,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M558.64489,562.33634s15.51256,2.21609,20.68342,16.25126,9.603,25.85427,18.46733,23.63819,3.69347-30.28643,3.69347-30.28643,18.46734,2.21608,19.206-4.43216c.61161-5.50448.21044-26.707.05431-33.8394a14.61639,14.61639,0,0,0-2.5474-8.08146,10.65642,10.65642,0,0,0-10.80339-4.61683,86.23893,86.23893,0,0,1-12.35576.64616,37.66766,37.66766,0,0,0-20.88544,6.00208h0l-15.51256.7387Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#f2f2f2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 336.44891,
    y: 424.06576,
    width: 31.76382,
    height: 53.92462,
    fill: "#eb6475"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M588.409,592.48824a11.04452,11.04452,0,0,0-3.15171.453l.21065.70767a10.46147,10.46147,0,0,1,13.26185,8.07152l.72571-.13778a11.16668,11.16668,0,0,0-11.0465-9.09444Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M531.09779,333.30883l-2.96424,33.19947,5.92848,99.5984s13.6355,50.392-7.11417,49.20635-13.04265-52.76343-13.04265-52.76343l-9.48556-115.60529Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M513.90521,243.196l15.414,8.29986s20.74967,72.32741,8.89271,85.96291-36.1637,18.97112-37.3494,13.63549-5.33563-45.05642-5.33563-45.05642Z",
    transform: "translate(-198.55779 -94.68767)",
    fill: "#2f2e41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.8d0f9c68051db66ca6f48a1f7366fbbd.svg";
export { ForwardRef as ReactComponent };